import addressService from "../services/addressService";
import stationsService from "../services/stationsService";
import backupTaskService from "../services/backupTaskService";
import configurationsService from '../services/configurationsService';
import backupsService from '../services/backupsService';
import usersService from '../services/usersService';

export default {
  async GET_ADDRESS(state, value) {
    let count = 0;
    if (state.address.list.length === 0) {
      await addressService.getAddress(1).then(response => {
        count = response.data.data.totalElements;
      })
      await addressService.getAddress(count).then(response => {
        response.data.data.content.forEach(element => {
          state.address.list.push({
            id: element.id,
            tipo: element.type,
            calle: element.calle,
            colonia: element.colonia,
            noExt: element.numero_exterior,
            cp: element.cp,
            ciudad: element.ciudad
          })
        });
      })
    }
  },
  async GET_STATIONS(state) {
    let data = []
    const count = await stationsService.getStations()
    const resp = await stationsService.getStations('', '', count.data.data.totalElements)
    await resp.data.data.content.forEach((e, i) => {
      data.push({
        label: e.station + ' ' + e.name,
        option: e.id,
        id: e.id,
        station: e.station,
        key: i
      })
    })

    localStorage.setItem('stationsJSON', JSON.stringify(data))
    state.stations.select = data
    data = []
  },
  async GET_TASKS(state, value) {
    let count = 0;
    if (state.tasks.list.length === 0) {
      await backupTaskService.getBackupTasks(1).then(response => {
        count = response.data.data.totalElements;
      })
      await backupTaskService.getBackupTasks(count).then(response => {
        response.data.data.content.forEach(element => {
          state.tasks.list.push({
            id: element.id,
            ruta: element.path,
            fecha: element.start_date,
            extension: element.format,
            tipo: element.type,
            periodo: element.period
          })
        });
      })
    }
  },
  async GET_CONFIGURATIONS(state, value) {
    // let count = 0;
    // if (state.configurations.list.length === 0) {
    //   await configurationsService.getConfigurations(1, '', '', 5).then(response => {
    //     count = response.data.data.totalElements;
    //   })
    //   await configurationsService.getConfigurations(0, '', null, count).then(response => {
    //     response.data.data.content.forEach(element => {
    //       state.configurations.select.push({
    //         label: element.id + ' - ' + element.name,
    //         option: element.id,
    //         id: element.id
    //       })
    //     });
    //   })
    // }
  },
  async GET_BACKUPS(state, value) {
    if (state.backups.list.length === 0) {
      await backupsService.getBackups().then(response => {
        response.data.data.forEach(element => {
          state.backups.list.push({
            id: element.id,
            estacion: element.station_id.station,
            fecha: element.uploaded_date,
            tamanio: element.filesize,
            archivo: element.file_name
          })
        });
      })
    }
  },
  async GET_USERS(state, value) {
    if (state.users.list.length === 0) {
      await usersService.getUsers().then(response => {
        response.data.data.forEach(element => {
          if (element.username === 'admin') { }
          else {
            state.users.list.push({
              id: element.id,
              usuario: element.username,
              nombre: element.name,
              email: element.email
            })
          }
        });
      })
    }
  }
}
